import { useSelector } from 'react-redux'

import { selectSignedInAccount } from 'redux/selectors/SignedInAccount'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

import {
  selectGroup,
  selectGroups,
  selectIsOwner,
  selectIsAddingMetricToGroup
} from 'redux/selectors/Groups'
import { ApplicationState } from 'redux/Stores/types'
import { SelectGroupMember } from 'types/GlobalGroup'

export const useGroups = () => useSelector(selectGroups)

export const useGroup = (id: string) => {
  return useSelector((state: ApplicationState) => selectGroup(state, id))
}

// return group_member of given group for current user.
export const useMember = (id: string): SelectGroupMember | null => {
  const user = useSelector(selectSignedInAccount)
  const group = useGroup(id)

  if (!user || !group) {
    return null
  }

  return (
    group.active_members.find((member) => member.account_id === user.id) || null
  )
}

/**
 * Returns if user has owner access to a group.
 * ie. owner, admin or homepal
 * @param id - id of group.
 * @returns - has owner access.
 */
export const useIsOwner = (id: string) => {
  return useSelector((state: ApplicationState) => selectIsOwner(state, id))
}

export const useIsLocked = (id: string) => {
  const { isAdmin } = useAccountSettings()
  const member = useMember(id)
  const group = useGroup(id)

  return !!group && group.is_private && !member && !isAdmin
}

export const useIsAddingMetricToGroup = () => {
  return useSelector(selectIsAddingMetricToGroup)
}
